import { Kits } from '@cheqroom/icons';
import type { TFunction } from 'i18next';
import { FC, ReactElement } from 'react';
import { Trans } from 'react-i18next';

import { Info } from '../../../Info';
import { useInfoT } from '../../../Info/Info.context';
import { useItemInfoContext } from '../../ItemInfo.context';

const toKitDetailPage = (id: string) => `/kits/${id}`;
const toItemDetailPage = (id: string, tab?: string) => `/items/${id}${tab ? `/${tab}` : ''}`;

interface Props {
	renderKitLink: (url: string) => ReactElement;
}

export const PartOfKitContent: FC<Props> = ({ renderKitLink }) => {
	const { item } = useItemInfoContext();
	const t = useInfoT('item-info');

	const isBulkItem = item.kind === 'bulk';
	if (isBulkItem ? !item.inKits : !item.kit) return null;

	const kits = Object.keys(item?.kitQuantities ?? {}).length;
	const url = isBulkItem ? toItemDetailPage(item._id, 'kits') : toKitDetailPage(item.kit!._id);

	return (
		<Info
			icon={Kits}
			text={
				<Trans
					// see StatusContent.tsx for why this cast is needed and safe (internal-only, same
					// i18next copy on both sides — Trans's `t` prop requires the real branded TFunction)
					t={t as unknown as TFunction}
					i18nKey={`part_of_kit.${isBulkItem ? 'bulk' : 'simple'}`}
					values={{ name: item.kit?.name, count: item.inKits, qtyInKits: item.inKits, kits }}
					// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment
					components={[renderKitLink(url)] as any}
				/>
			}
		/>
	);
};
